import { render, staticRenderFns } from "./MoneyRecord.vue?vue&type=template&id=f497c3d2&scoped=true"
import script from "./MoneyRecord.vue?vue&type=script&lang=js"
export * from "./MoneyRecord.vue?vue&type=script&lang=js"
import style0 from "./MoneyRecord.vue?vue&type=style&index=0&id=f497c3d2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f497c3d2",
  null
  
)

export default component.exports